import { useSearchParams } from 'react-router-dom';
import { ApplicantDetailsPage } from '../ApplicantDetailsPage';
import { getApplicantNumber } from './helpers';

export const ApplicantsWrapper = () => {
  const [searchParams] = useSearchParams();
  const applicantNumber = getApplicantNumber(searchParams);

  return <ApplicantDetailsPage key={`applicant-${applicantNumber}`} applicantNumber={applicantNumber} />;
};
